const Vue = require('vue')
import apihelper from './apihelper'
import config from '@/util/config'
import {
  Toast
} from 'vant'

export default {
  oauth(code) {
    return new Promise((resolve, reject) => {
      var toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
        message: '加载中...'
      })
      Vue.http.post(config.authhost + "/connect/token", {
        client_id: 'community',
        client_secret: 'community_src#@.31k2',
        grant_type: 'WX',
        WXCode: code,
        scope: "api.community.h5"
      }, {
        emulateJSON: true,
        'X-Requested-With': 'XMLHttpRequest'
      }).then((response) => {
        if (toast)
          toast.clear()
        var token = response.body;
        resolve(response.body);
      }, (e) => {
        if (toast) {
          toast.clear()
        }
        resolve(e.body);
      })
    })
  },
  login(phone, code) {
    return new Promise((resolve, reject) => {
      var toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
        message: '加载中...'
      })
      Vue.http.post(config.authhost + "/connect/token", {
        client_id: 'community',
        client_secret: 'community_src#@.31k2',
        grant_type: 'WX',
        OpenId: config.wx.openid,
        UnionId: config.wx.unionid,
        Phone: phone,
        SmsCode: code,
        scope: "api.community.h5"
      }, {
        emulateJSON: true
      }).then((response) => {
        if (toast)
          toast.clear()
        var token = response.body;
        resolve(response.body);
      }, (e) => {
        if (toast)
          toast.clear()
        resolve(e.body );
      })
    })
  },
  getLoginData() {
    return apihelper.get("/Account/GetLogin");
  },
  sendCode(p) {
    return apihelper.get("/Common/SetLoginCode", p);
  }
}
